import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

export type GroupProduct = {
  group_product_id?: number; // 그룹 상품 idx
  group_product_title?: string; // 그룹상품 명
  group_product_content?: string; // 그룹상품 내용
  group_product_description?: string; // 그룹상품 설명
  thumbnail_url?: string; //이미지 주소
  is_show?: string; // 노출여부
  is_main?: string; // 노출여부
  order?: string; // 노출여부
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
};
export type MapCreateGroupProductRequest = {
  group_product: GroupProduct;
  product_policy: {
    policy_type: 'GROUP';
    discount_rate: number;
    reserve_rate: number;
    discount_type: 'W' | 'R';
    reserve_type: 'W' | 'R';
    commission_rate: number;
    commission_type: number;
    share_ratio: number;
    is_show: 'Y' | 'N';
  };
  product_ids: { product_id: number }[];
};
const $http = new APIManager();

const Api = {
  /**
   * [GETS] GroupProduct
   * --
   */
  getGroupProducts: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_GROUP_PRODUCT, params);

      return res;
    } catch (e) {
      throw e;
    }
  },
  /**
   * [GETS] MapGroupProduct
   * --
   */
  getMapGroupProducts: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_MAP_GROUP_PRODUCT, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] GroupProduct
   * --
   */
  getGroupProduct: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_GROUP_PRODUCT, {
        group_product_id: idx,
      });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] GroupProduct
   * --
   */
  createGroupProduct: async (body: GroupProduct) => {
    try {
      const res = await $http.post(APIConstant.CREATE_GROUP_PRODUCT, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] GroupProduct
   * --
   */
  updateGroupProduct: async (body: GroupProduct) => {
    try {
      const { group_product_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_GROUP_PRODUCT, {
        group_product_id: group_product_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] GroupProduct
   * --
   */
  deleteGroupProduct: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_GROUP_PRODUCT, {
        group_product_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [UPSERT] GroupProduct
   * --
   */
  upsertGroupProduct: async (body: GroupProduct[]) => {
    try {
      const res = await $http.bulk(
        APIConstant.BULK_UPSERT_GROUP_PRODUCT,
        body,
        'PUT'
      );

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] GroupProduct
   * --
   */
  mapCreateGroupProduct: async (body: MapCreateGroupProductRequest) => {
    try {
      const res = await $http.post(APIConstant.MAP_CREATE_GROUP_PRODUCT, body);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
